import Button from '../../../../shared/Button';
import { Tooltip } from '@mui/material';
import React from 'react';
import { t } from 'i18next';
import { useSetRecoilState } from 'recoil';
import { useData } from '../../../../../data-layer';
import { deleteAllCuratedTestIds } from '../../../../shared/TestsIds';
import useConfirm from '../../../../../hooks/General/useConfirm';

export default function DeleteAllCuratedButton({
  curatedItemsCount,
  hasDeletePermission
}: {
  curatedItemsCount: number;
  hasDeletePermission: boolean;
}): React.ReactElement {
  const {
    collections: {
      state: { withSelectedCollectionContent, withPinnedCollectionContent }
    }
  } = useData();
  const setSelectedCollectionContents = useSetRecoilState(withSelectedCollectionContent);
  const setPinnedCollectionContents = useSetRecoilState(withPinnedCollectionContent);
  const { confirm } = useConfirm();

  const isDisabled = !hasDeletePermission || curatedItemsCount === 0;

  const onDeleteAll = async () => {
    const result = await confirm({
      confirmColor: 'error',
      confirmText: t('confirm.confirm_delete_button'),
      body: t('general.delete_all_curated_confirm', { n: curatedItemsCount }),
      'data-testid': deleteAllCuratedTestIds.deleteAllConfirm
    });

    if (!result) return;

    setSelectedCollectionContents([]);
    setPinnedCollectionContents([]);
  };

  return (
    <Tooltip title={t('general.delete_all_curated_tooltip')}>
      <span>
        <Button
          color="error"
          size="small"
          disabled={isDisabled}
          data-testid={deleteAllCuratedTestIds.deleteAllButton}
          onClick={onDeleteAll}
        >
          {t('general.delete_all_curated')}
        </Button>
      </span>
    </Tooltip>
  );
}
